import {css, unsafeCSS} from "lit";
import {imgPath} from "../../../main/utils/common.js";

const icon = (filename: string, iconTag: string) => {
	const filePath = unsafeCSS(imgPath(filename));
	return css`
		.${unsafeCSS(iconTag)},
		::slotted(.${unsafeCSS(iconTag)}) {
			background-image: url('${filePath}');
			background-repeat: no-repeat;
			background-position-x: center;
			background-position-y: center;
			background-size: contain;
		}

		.${unsafeCSS(iconTag)}.icon-mask,
		::slotted(.${unsafeCSS(iconTag)}.icon-mask) {
			mask: url('${filePath}') center no-repeat;
			-webkit-mask: url('${filePath}') center no-repeat;
		}
	`;
};

export const iconStyles = css`
	i[class*="icon-"],
	::slotted(i[class*="icon-"]) {
		display: block;
		/** Declaring size this way allows size adjustments via font-size wherever we want **/
		height: 1em;
		width: 1em;
	}

	i[class*="icon-"].icon-mask,
	::slotted(i[class*="icon-"].icon-mask) {
		background-image: none;
		mask-size: 1em;
		-webkit-mask-size: 1em;
	}

	${icon("icon_account.svg", "icon-account")}
	${icon("icon_add.svg", "icon-add")}
	${icon("icon_bookmark_outline.svg", "icon-bookmark-outline")}
	${icon("icon_bookmark_solid.svg", "icon-bookmark-solid")}
	${icon("icon_brain.svg", "icon-brain")}
	${icon("icon_chevron_light_down.svg", "icon-chevron-light-down")}
	${icon("icon_chevron_light_right.svg", "icon-chevron-light-right")}
	${icon("icon_circle.svg", "icon-circle")}
	${icon("icon_citation_outline.svg", "icon-citation-outline")}
	${icon("icon_citation_outline_green.svg", "icon-citation-outline-green")}
	${icon("icon_citation_solid.svg", "icon-citation-solid")}
	${icon("icon_citation_solid_green.svg", "icon-citation-solid-green")}
	${icon("icon_close.svg", "icon-close")}
	${icon("icon_disable.svg", "icon-disable")}
	${icon("icon_download.svg", "icon-download")}
	${icon("icon_edit.svg", "icon-edit")}
	${icon("icon_expand.svg", "icon-expand")}
	${icon("icon_filter.svg", "icon-filter")}
	${icon("icon_settings.svg", "icon-settings")}
	${icon("icon_freeform_note.svg", "icon-freeform-note")}
	${icon("icon_help.svg", "icon-help")}
	${icon("icon_refresh_circle.svg", "icon-refresh-circle")}
	${icon("icon_round_alt_arrow_down.svg", "icon-round-alt-arrow-down")}
	${icon("icon_three_dots.svg", "icon-three-dots")}
	${icon("icon_trash.svg", "icon-trash")}
`;
